import React, { useCallback, useEffect, useState } from "react";
import ExpiredAdminModal from "./ExpiredAdminModal";
import InvitationAdminModal from "./InvitationAdminModal";
import KeepAccountModal from "./KeepAccountModal";
import { useAppSelector } from "redux/hooks";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAuth } from "components/Auth";
import { isWithinDays } from "utils/timeUtil";

export default function TransferAdmin() {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const [expiredOwner, setExpiredOwner] = useState<boolean>(false);
  const [invitationAdmin, setInvitationAdmin] = useState<boolean>(false);
  const [keepAccount, setKeepAccount] = useState<boolean>(false);
  const { user } = useAuth();

  const checkInviteOwner = () => {
    setExpiredOwner(false);
    if (
      // 5일 이상 생성된 org이고 초대된 admin이 없으면
      isWithinDays(selectedAccount.createdAt, 5, false) &&
      !selectedAccount?.invitedOwner
    ) {
      setInvitationAdmin(true);
    } else {
      setInvitationAdmin(false);
    }
  };
  const checkOrgCreator = useCallback(() => {
    if (
      selectedAccount.isHidden || // hidden 상태면 팝업 띄우지 않음
      selectedAccount.isDecide === 999 || // 이미 모든 작업이 끝난 org이면 팝업 띄우지 않음
      selectedAccount.isDecide < 0 // 오류난 상태면 팝업 띄우지 않음
    ) {
      return;
    }
    // org 생성자 라면
    if (selectedAccount?.isCreator) {
      // 보지 않기 팝업 체크 여부
      const checkedDontShow = localStorage.getItem(
        `${selectedAccount.accountId}-expired-owner`
      );

      if (
        isWithinDays(selectedAccount.createdAt, 30) &&
        selectedAccount.isDecide < 2 &&
        !checkedDontShow
      ) {
        // 30일 이내 생성된 org이고 팝업 보지 않기 체크 안되어 있으면
        setExpiredOwner(true);
      } else {
        //어드민 만료 공지 팝업을 안보는 생성자라면 admin 초대여부 확인
        checkInviteOwner();
      }
    } else if (
      selectedAccount.ownerId === user.userId &&
      isWithinDays(selectedAccount.createdAt, 20, false) &&
      selectedAccount.isDecide === 0 //(0: 미결정, 1: 삭제, 2: 유지, 3: 완료)
    ) {
      //생성자가 아니고 내가 owner라면 이전 생성자를 admin으로 남겨둘지 여부 체크 팝업 띄우기
      setKeepAccount(true);
    } else {
      setExpiredOwner(false);
      setInvitationAdmin(false);
      setKeepAccount(false);
    }
  }, [selectedAccount.accountId, user.verify2fa]);

  useEffect(() => {
    checkOrgCreator();
  }, [checkOrgCreator]);

  if (expiredOwner) {
    return <ExpiredAdminModal onModal={() => checkInviteOwner()} />;
  }
  if (invitationAdmin) {
    return <InvitationAdminModal onModal={() => setInvitationAdmin(false)} />;
  }
  if (keepAccount) {
    return <KeepAccountModal onModal={() => setKeepAccount(false)} />;
  }
  return <></>;
}
